import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { formatMoney } from '../../../util/currency';

import css from '../OrderItemInfo.css';

const ServiceFeeItem = ({ serviceFeeLineItem = [], intl, idMessage }) => {

  return (
    <div key="confirm">
      <p className={classNames(css.text, css.priceContainer)} key="serviceFee">
        <span className={css.productName}>
          <FormattedMessage id="TransactionPanel.serviceFee" />
        </span>
        <span className={css.text}>
          {formatMoney(intl, serviceFeeLineItem[0].lineTotal)}
        </span>
      </p>
      <p className={classNames(css.subtitle, css.borderBottom, css.priceContainer)}>
        <FormattedMessage id={idMessage} /> {formatMoney(intl, serviceFeeLineItem[0].lineTotal)}
      </p>
    </div>
  );
}

export default ServiceFeeItem;
